import LegalLayout from "components/LegalLayout"

const PrivacyPage = () => (
  <LegalLayout title="Privacy Policy" lastUpdated="June 8, 2026" path="/privacy">
    <h2>1. Overview</h2>
    <p>
      This Privacy Policy explains how r4v3n LLC (&ldquo;r4v3n,&rdquo; &ldquo;we,&rdquo;
      &ldquo;us,&rdquo; or &ldquo;our&rdquo;) handles information in connection with this website (the
      &ldquo;Site&rdquo;). The Site is an art portfolio. It does not offer user accounts, and we aim
      to collect as little personal data as possible.
    </p>

    <h2>2. Information we collect</h2>
    <p>
      We do not ask you to create an account or submit personal information to browse the Site. We
      collect only:
    </p>
    <ul>
      <li>
        <strong>Standard server logs.</strong> Our hosting provider automatically records technical
        information such as IP address, browser type, referring page, and timestamps as part of
        delivering and securing the Site.
      </li>
      <li>
        <strong>Wallet address (only if you connect a wallet).</strong> If you choose to connect a
        cryptocurrency wallet, your public wallet address is processed to display on-chain
        information. We do not collect private keys, and we never have access to your funds.
      </li>
      <li>
        <strong>Theme preference.</strong> Your light/dark theme choice is stored locally in your
        browser (localStorage) and is not transmitted to us.
      </li>
    </ul>
    <p>The Site does not currently use analytics or advertising trackers.</p>

    <h2>3. How we use information</h2>
    <p>
      We use the limited information above to operate, secure, maintain, and improve the Site. We do
      not sell your personal information, and we do not use it for advertising.
    </p>

    <h2>4. Third-party services</h2>
    <p>The Site relies on a small number of third-party services that may process technical data:</p>
    <ul>
      <li>
        <strong>Vercel</strong> &mdash; website hosting and content delivery (server logs as
        described above).
      </li>
      <li>
        <strong>Google Fonts</strong> &mdash; web fonts are loaded from Google&rsquo;s CDN, which may
        receive your IP address as part of serving font files.
      </li>
      <li>
        <strong>Blockchain and marketplace data providers</strong> &mdash; we display on-chain
        artwork and metadata via services such as Art Blocks, public Ethereum and Arbitrum nodes, and
        the relevant marketplaces. Requests to those services are subject to their own privacy
        practices.
      </li>
    </ul>
    <p>
      Information recorded on public blockchains (including wallet addresses and transactions) is
      inherently public and outside our control.
    </p>

    <h2>5. Cookies</h2>
    <p>
      The Site does not set advertising or tracking cookies. It uses your browser&rsquo;s local
      storage only to remember your theme preference and to support wallet connectivity if you
      choose to use it.
    </p>

    <h2>6. Your rights</h2>
    <p>
      Depending on your location, you may have rights under laws such as the EU/UK GDPR or the
      California Consumer Privacy Act (CCPA), including the right to access, correct, or delete
      personal information we hold about you, and the right not to be discriminated against for
      exercising those rights. Because we collect very little personal data and maintain no user
      accounts, in most cases we hold no information that identifies you. To make a request, contact
      us using the details below.
    </p>

    <h2>7. Children&rsquo;s privacy</h2>
    <p>
      The Site is not directed to children under 13 (or the minimum age required in your
      jurisdiction), and we do not knowingly collect personal information from children. If you
      believe a child has provided us with personal information, please contact us and we will take
      appropriate steps to delete it.
    </p>

    <h2>8. Changes to this policy</h2>
    <p>
      We may update this Privacy Policy from time to time. Updates will be posted on this page with a
      new &ldquo;Last updated&rdquo; date.
    </p>

    <h2>9. Contact</h2>
    <p>
      Questions about this Privacy Policy may be directed to r4v3n LLC at{" "}
      <a href="mailto:support@r4v3n.art">support@r4v3n.art</a>.
    </p>
  </LegalLayout>
)

export default PrivacyPage
